module.exports = __webpack_public_path__ + "img/选妃未选中.df905a7f.png";